// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1nowO","large":"styles_large__1abh4"};